import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './i18n'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

async function registerProgressiveWebApp() {
  if (!('serviceWorker' in navigator)) return
  try {
    const registration = await navigator.serviceWorker.register('/sw.js')
    const vapidKey = (import.meta as any).env.VITE_VAPID_PUBLIC_KEY as string | undefined
    if (!vapidKey || !('PushManager' in window) || Notification.permission === 'denied') return
    if (Notification.permission === 'default') return

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: Uint8Array.from(atob(vapidKey.replace(/-/g, '+').replace(/_/g, '/')), (char) => char.charCodeAt(0)),
    })
    await fetch('/api/push', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(subscription.toJSON()),
    })
  } catch (error) {
    // PWA and push are progressive enhancements; login must not be affected.
    console.debug('[pwa] registration skipped:', error)
  }
}

if (typeof window !== 'undefined') void registerProgressiveWebApp()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
